import { UserActivityLogModel } from "src/app/shared/models/userActivityLog.model";
import { SurveySubmissionStatus } from "src/app/shared/survey-submission-status.enum";

export class QuestionResponses {
  sectionId: number;
  questionId: number;
  questionReponse: string;
  surveyResponseRelId? : number;
}

export class SurveyResponseClass {
  surveyId: string;
  surveyResponseID: number;
  surveyUserESign: string;  
  groupId:string;
  workflowStepId:number;
  questionResponses: QuestionResponses[];
  surveySubmissionStatus: SurveySubmissionStatus;
  //groupId:string;
  isAnonymousResponse : boolean = false;
  fingerprint: string;
  userActivityLog? : UserActivityLogModel;
  businessProcessId :string;
  incidentId:number;
  surveyInstanceId :string;
  lookupInstances :string[] =[];
  incidentCreateShouldLog : boolean;
}


